import React from "react";

interface CapybaraCanvasProps {
  selectedItems: Record<string, string>;
}

export default function CapybaraCanvas({ selectedItems }: CapybaraCanvasProps) {
  return (
    <div className="relative w-64 h-64 bg-white rounded-lg shadow-md flex items-center justify-center">
      {/* 🦦 Base Capybara */}
      <img
        src="/assets/capybara/capybara_base.png"
        alt="Capybara base"
        className="absolute inset-0 w-full h-full object-contain"
      />

      {/* 🧢 Dynamic overlays */}
      {Object.entries(selectedItems).map(([category, overlayFile]) => {
        const fullPath = `/assets/capybara/${overlayFile}`;
        return (
          <img
            key={category}
            src={fullPath}
            alt={`${category} item`}
            className="absolute inset-0 w-full h-full object-contain"
            onError={(e) => {
              console.warn("❌ Missing overlay image:", fullPath);
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
        );
      })}
    </div>
  );
}
